var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_contact") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u7247",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u753B\\u677F",
    transform: "translate(-276, -273)",
    stroke: "#0E1C39",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(282, 277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21,5.99804741 L17.3789427,5.99804741 C17.0475718,5.99804741 16.7789427,5.72941826 16.7789427,5.39804741 L16.7789427,0.06 C16.7789427,0.026862915 16.8058056,6.65081676e-17 16.8389427,6.24500451e-17 L18.8311572,0 C19.9645641,-2.08203456e-16 20.8833718,0.918807771 20.8833718,2.05221459 L20.8833718,9.59687585 C20.8833718,14.897084 16.5867042,19.1937517 11.286496,19.1937517 L9.71714283,19.1937517 C4.41693465,19.1937517 0.120266981,14.897084 0.120266981,9.59687585 L0.120266981,2.05221459 C0.120266981,0.918807771 1.03907475,1.64880353e-15 2.17248158,0 L4.16469617,-6.9388939e-18 C4.19783325,-1.30260777e-17 4.22469617,0.026862915 4.22469617,0.06 L4.22469617,5.39804741 C4.22469617,5.72941826 3.95606702,5.99804741 3.62469617,5.99804741 L0,5.99804741 L0,5.99804741",
    id: "\\u77E9\\u5F62",
    transform: "translate(10.5, 9.5969) rotate(-180) translate(-10.5, -9.5969)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.47569049,19.1937517 L2.47569049,19.2 C2.47569049,21.8509668 4.6247237,24 7.27569049,24 L9.5,24 L9.5,24",
    id: "\\u8DEF\\u5F84-3",
    strokeLinecap: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContact);
export default __webpack_public_path__ + "static/media/icon_contact.5d2dc7dc9cba448d047d2e07893b6bea.svg";
export { ForwardRef as ReactComponent };